import { GENRE_LABEL, type LibraryEntry } from "@/data/aiWorkflows";

const normalize = (text: string) =>
  text
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .match(/[\p{L}\p{N}]+/gu)
    ?.join(" ") ?? "";

// Search task descriptions and inputs. Queries stay in the browser and are
// never included in analytics or referral URLs.
export function searchWorkflows(
  entries: LibraryEntry[],
  query: string,
  categoryId = "all",
): LibraryEntry[] {
  const terms = normalize(query).split(" ").filter(Boolean);
  return entries.filter((entry) => {
    if (categoryId !== "all" && entry.category.id !== categoryId) return false;
    const text = normalize(
      [
        entry.title,
        entry.purpose,
        GENRE_LABEL[entry.category.id],
        ...entry.requiredInputs,
        ...entry.optionalInputs,
      ].join(" "),
    );
    return terms.every((term) => text.includes(term));
  });
}

export const WORKFLOWS_PER_PAGE = 12;

// Filter the complete catalog before taking a page, including matches that
// were not part of the initial twelve cards.
export function browseWorkflows(
  entries: LibraryEntry[],
  query: string,
  categoryId = "all",
  limit = WORKFLOWS_PER_PAGE,
) {
  const matches = searchWorkflows(entries, query, categoryId);
  return { matches, visible: matches.slice(0, limit) };
}
